import tokens from '../tokens/js/tokens';
import { getFontWeight } from './typography.utils';
// Default typography.
// -----------------------------------------------------------------------------
export const typography = {
    // Default props.
    fontFamily: tokens.font.family.sans.value,
    fontEditorial: tokens.font.family.display.value,
    fontWeight: tokens.font.weight.medium.value,
    // Header
    header: {
        h1: {
            fontSize: tokens.font.size['6xl'].value,
            fontWeight: tokens.font.weight.extraBold.value,
            marginBottom: tokens.spacing['2xl'].value,
            lineHeight: tokens.font.lineHeight.header.value
        },
        h2: {
            fontSize: tokens.font.size['5xl'].value,
            fontWeight: tokens.font.weight.extraBold.value,
            marginBottom: tokens.spacing['2xl'].value,
            lineHeight: tokens.font.lineHeight.header.value
        },
        h3: {
            fontSize: tokens.font.size['4xl'].value,
            fontWeight: tokens.font.weight.extraBold.value,
            marginBottom: tokens.spacing['2xl'].value,
            lineHeight: tokens.font.lineHeight.header.value
        },
        h4: {
            fontSize: tokens.font.size['3xl'].value,
            fontWeight: tokens.font.weight.extraBold.value,
            marginBottom: tokens.spacing.l.value,
            lineHeight: tokens.font.lineHeight.header.value
        },
        h5: {
            fontSize: tokens.font.size['2xl'].value,
            fontWeight: tokens.font.weight.extraBold.value,
            marginBottom: tokens.spacing.l.value,
            lineHeight: tokens.font.lineHeight.header.value
        },
        h6: {
            fontSize: tokens.font.size.xl.value,
            fontWeight: tokens.font.weight.extraBold.value,
            marginBottom: tokens.spacing.m.value,
            lineHeight: tokens.font.lineHeight.header.value
        }
    },
    // Paragraph
    paragraph: {
        '2xs': {
            fontSize: tokens.font.size['2xs'].value,
            lineHeight: tokens.font.lineHeight.body.value
        },
        '1xs': {
            fontSize: tokens.font.size['xs'].value,
            lineHeight: tokens.font.lineHeight.body.value
        },
        s: {
            fontSize: tokens.font.size.s.value,
            lineHeight: tokens.font.lineHeight.body.value
        },
        m: {
            fontSize: tokens.font.size.m.value,
            lineHeight: tokens.font.lineHeight.body.value
        },
        l: {
            fontSize: tokens.font.size.l.value,
            lineHeight: tokens.font.lineHeight.body.value
        },
        '1xl': {
            fontSize: tokens.font.size.xl.value,
            lineHeight: tokens.font.lineHeight.body.value
        },
        '2xl': {
            fontSize: tokens.font.size['2xl'].value,
            lineHeight: tokens.font.lineHeight.body.value
        }
    },
    // Text.
    text: {
        '2xs': {
            fontSize: tokens.font.size['2xs'].value,
            fontWeight: getFontWeight('black'),
            letterSpacing: tokens.font.letterSpacing.s.value,
            lineHeight: tokens.font.lineHeight.text.value
        },
        xs: {
            fontSize: tokens.font.size.xs.value,
            fontWeight: getFontWeight('black'),
            letterSpacing: tokens.font.letterSpacing.s.value,
            lineHeight: tokens.font.lineHeight.text.value
        },
        s: {
            fontSize: tokens.font.size.s.value,
            fontWeight: getFontWeight('black'),
            letterSpacing: tokens.font.letterSpacing.s.value,
            lineHeight: tokens.font.lineHeight.text.value
        },
        m: {
            fontSize: tokens.font.size.m.value,
            fontWeight: getFontWeight('black'),
            letterSpacing: tokens.font.letterSpacing.m.value,
            lineHeight: tokens.font.lineHeight.text.value
        },
        l: {
            fontSize: tokens.font.size.l.value,
            fontWeight: getFontWeight('black'),
            letterSpacing: tokens.font.letterSpacing.m.value,
            lineHeight: tokens.font.lineHeight.text.value
        },
        xl: {
            fontSize: tokens.font.size.xl.value,
            fontWeight: getFontWeight('black'),
            letterSpacing: tokens.font.letterSpacing.m.value,
            lineHeight: tokens.font.lineHeight.text.value
        },
        '2xl': {
            fontSize: tokens.font.size['2xl'].value,
            fontWeight: getFontWeight('black'),
            letterSpacing: tokens.font.letterSpacing.m.value,
            lineHeight: tokens.font.lineHeight.text.value
        }
    }
};
//# sourceMappingURL=typography.js.map